import "./Quote.scss";
import Card from 'react-bootstrap/Card';
import { useEffect, useRef, useState } from "react";
import loader from "../assets/images/loader.gif";
import { useForm } from "react-hook-form";
import WebService from "../utility/WebService";
import HelperService from "../utility/HelperService";

interface propData {
    data: any
}

const QuoteInfo = (props: propData) => {

    return (
        <>
            <div className=' '>
                <Card className="card-style form-style p-2" style={{ marginBottom: 50 }}>
                    <Card.Body className="border-bottom border-light">
                        <div className="mb-0 font-w-medium font-15">Quote Description</div>
                        <div dangerouslySetInnerHTML={{ __html: props?.data?.quoteDescription }} />
                        <div className="text-end mt-4">
                            {props?.data?.signature && <img src={`data:image/png;base64,${props?.data?.signature}`} style={{ height: 150, width: 200 }} />}
                            <div style={{ marginRight: 50, }}>
                                {props?.data?.signedBy && <div>{props?.data?.signedBy}</div>}
                                {props?.data?.signatureDate && <div>{HelperService.getFormatedDateAndTime(props?.data?.signatureDate)}</div>}
                            </div>
                        </div>
                    </Card.Body>
                </Card>
            </div>
        </>
    )
}

export default QuoteInfo;